// extracted by mini-css-extract-plugin
export var backdropBlur = "_ly-0";
export var contentCard = "_ly-5";
export var frame = "_ly-2";
export var image = "_ly-4";
export var imagePane = "_ly-3";
export var modal = "_ly-1";